import { Fragment } from 'react';

import HeaderComponent from '../HeaderComponent/HeaderComponent';

const Layout = (props) => {
  return (
    <Fragment>
      <HeaderComponent />
      <main>{props.children}</main>
    </Fragment>
  );
};

export default Layout;
